import { Col, Container, Row, Badge } from 'react-bootstrap';
import { FaMapMarkerAlt } from 'react-icons/fa';
import AreaHighlights from './AreaHighlights';

const Hero = ({ sectionData }) => {
  // Use database data if available, otherwise fallback to hardcoded
  const subtitle = sectionData?.subtitle || 'East Crete Travel Guide';
  const title = sectionData?.title || 'Discover Beautiful East Crete';
  const introText = sectionData?.intro_text || 
    'Presenting a suite of services in East Crete, including hotels, transfers, excursions, and car rentals, all available within the region. East Crete is the region located Eastern of Heraklion and reaches until Palekastro in Sitia. It consists of several destinations that have attracted a lot of travellers.';
  const items = sectionData?.items || [];
  const bgColor = sectionData?.background_color || 'light';
  const bgEffect = sectionData?.background_effect || null;
  let bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : 'bg-light';
  if (bgColor === 'primary' && bgEffect === 'gradient') {
    bgClass = 'section-bg-primary-gradient';
  }
  const hasDotsEffect = bgColor === 'primary' && bgEffect === 'dots';

  return (
    <section className={`pt-0 pb-5 pb-lg-6 ${bgClass} east-crete-hero-section ${hasDotsEffect ? 'position-relative overflow-hidden' : ''}`}>
      {hasDotsEffect && (
        <>
          <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
          <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
        </>
      )}
      <Container>
        <Row className="mb-5">
          <Col xl={10} className="mx-auto text-center">
            {subtitle && (
              <Badge bg="primary" className="mb-4 px-3 py-2 fs-6 fw-normal">
                <FaMapMarkerAlt className="me-2" />
                {subtitle}
              </Badge>
            )}
            {title && (
              <h1 className="sec-title mb-3">
                {title}
              </h1>
            )}
            {introText && (
              <p className="lead intro-text mb-4" dangerouslySetInnerHTML={{ __html: introText }} />
            )}
            {items.length > 0 && (
              <div className="d-flex flex-wrap gap-3 justify-content-center">
                {items.map((item, index) => {
                  const IconComponent = item.IconComponent;
                  const normalizedColor = (item.icon_color || 'primary').toString().trim().toLowerCase();
                  const iconColorClass = normalizedColor === 'primary' ? 'bg-primary bg-opacity-10 text-primary' :
                                        normalizedColor === 'success' ? 'bg-success bg-opacity-10 text-success' :
                                        normalizedColor === 'warning' ? 'bg-warning bg-opacity-10 text-warning' :
                                        normalizedColor === 'danger' ? 'bg-danger bg-opacity-10 text-danger' :
                                        normalizedColor === 'info' ? 'bg-info bg-opacity-10 text-info' :
                                        normalizedColor === 'secondary' ? 'bg-secondary bg-opacity-10 text-secondary' :
                                        'bg-primary bg-opacity-10 text-primary';
                  
                  return (
                    <div key={item.id || index} className="bg-light rounded-3 p-3 px-4">
                      <div className="d-flex align-items-center gap-2">
                        {IconComponent && (
                          <div className={`icon-md ${iconColorClass} rounded-circle flex-centered`}>
                            <IconComponent />
                          </div>
                        )}
                        <div>
                          {item.title && <h6 className="mb-0 fw-bold">{item.title}</h6>}
                          {item.description && <small className="text-muted" dangerouslySetInnerHTML={{ __html: item.description }} />}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </Col>
        </Row>

        <AreaHighlights />
      </Container>
    </section>
  );
};

export default Hero;

